import { render } from "./hr-button-save.vue?vue&type=template&id=b2c7b428&scoped=true"
import script from "./hr-button-save.vue?vue&type=script&lang=js"
export * from "./hr-button-save.vue?vue&type=script&lang=js"

import "./hr-button-save.vue?vue&type=style&index=0&id=b2c7b428&scoped=true&lang=css"

import exportComponent from "/home/jenkins/workspace/DeputyApp_web-hr_202604021339/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2c7b428"]])

export default __exports__